import { WidgetStyle } from "./widgetTypes";
export enum POSITION {
    LEFT_BOTTOM = "left-bottom",
    LEFT_TOP = "left-top",
    RIGHT_BOTTOM = "right-bottom",
    RIGHT_TOP = "right-top",
}
export type InitType = {
    store_id: number;
    current_plan?: string;
    domain?: string;
    api_url?: string;
    locale?: string;
};

export type CardStyle = {
    width?: string;
    height?: string;
    minHeight?: string;
    maxWidth?: string;
    borderRadius?: string;
    boxShadow?: string;
    backgroundColor?: string;
    color?: string;
    fontSize?: string;
    fontFamily?: string;
    fontWeight?: string;
    padding?: string;
    margin?: string;
    position?: POSITION;
};


export enum ACTION_VARIANT {
    PRIMARY = "primary",
    SECONDARY = "secondary",
    PLAIN = "plain",
}

export type Actions = {
    icon?: boolean;
    label: string;
    url: string;
    external?: boolean;
    variant?: ACTION_VARIANT;
};

export type DataType = {
    id?: string;
    type: WidgetStyle;
    priority?: number;
    img_url?: string;
    title?: string;
    description?: string;
    date?: string;
    primary_action?: Actions;
    secondary_action?: Actions;
    secondary_actions?: Actions | Actions[];
    tag?: {
        label: string;
        tone: string;
    };
    dismissible?: boolean;
    auto_close_after?: number | null;
    reappear_interval?: 'after_1_day' | 'after_7_days' | null;
};

export type DataListType = {
    type?: WidgetStyle;
    title?: string;
    subtitle?: string;
    data: Partial<DataType[]>;
    view_all?: {
        label: string;
        url: string;
    };
}